{
  "insightId": "sAi8kXXemb0D",
  "kind": 3,
  "computationKind": 3,
  "dxObject": { "id": "dUepQnDR4cA1", "version": "1631908392118", "supportedDxObjectType": 1 },
  "computedAt": "2022-08-29T15:04:49.954547442Z",
  "computationHash": "testComputationHash",
  "start": "2022-05-01T04:00:00Z",
  "end": "2022-08-29T04:00:00Z",
  "createdAt": "2022-08-29T15:04:49.974012Z",
  "updatedAt": "2022-08-29T15:04:49.974012Z",
  "trend": {
    "data": {
      "metricsDataTable": {
        "table": [
          {
            "startTime": "2022-03-31T04:00:00Z",
            "endTime": "2022-04-01T04:00:00Z",
            "groups": [],
            "value": 18,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-01T04:00:00Z",
            "endTime": "2022-04-02T04:00:00Z",
            "groups": [],
            "value": 17,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-02T04:00:00Z",
            "endTime": "2022-04-03T04:00:00Z",
            "groups": [],
            "value": 7,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-03T04:00:00Z",
            "endTime": "2022-04-04T04:00:00Z",
            "groups": [],
            "value": 3,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-04T04:00:00Z",
            "endTime": "2022-04-05T04:00:00Z",
            "groups": [],
            "value": 18,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-05T04:00:00Z",
            "endTime": "2022-04-06T04:00:00Z",
            "groups": [],
            "value": 32,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-06T04:00:00Z",
            "endTime": "2022-04-07T04:00:00Z",
            "groups": [],
            "value": 23,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-07T04:00:00Z",
            "endTime": "2022-04-08T04:00:00Z",
            "groups": [],
            "value": 22,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-08T04:00:00Z",
            "endTime": "2022-04-09T04:00:00Z",
            "groups": [],
            "value": 17,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-09T04:00:00Z",
            "endTime": "2022-04-10T04:00:00Z",
            "groups": [],
            "value": 6,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-10T04:00:00Z",
            "endTime": "2022-04-11T04:00:00Z",
            "groups": [],
            "value": 1,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-11T04:00:00Z",
            "endTime": "2022-04-12T04:00:00Z",
            "groups": [],
            "value": 17,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-12T04:00:00Z",
            "endTime": "2022-04-13T04:00:00Z",
            "groups": [],
            "value": 14,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-13T04:00:00Z",
            "endTime": "2022-04-14T04:00:00Z",
            "groups": [],
            "value": 10,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-14T04:00:00Z",
            "endTime": "2022-04-15T04:00:00Z",
            "groups": [],
            "value": 19,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-15T04:00:00Z",
            "endTime": "2022-04-16T04:00:00Z",
            "groups": [],
            "value": 13,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-16T04:00:00Z",
            "endTime": "2022-04-17T04:00:00Z",
            "groups": [],
            "value": 25,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-17T04:00:00Z",
            "endTime": "2022-04-18T04:00:00Z",
            "groups": [],
            "value": 6,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-18T04:00:00Z",
            "endTime": "2022-04-19T04:00:00Z",
            "groups": [],
            "value": 10,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-19T04:00:00Z",
            "endTime": "2022-04-20T04:00:00Z",
            "groups": [],
            "value": 14,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-20T04:00:00Z",
            "endTime": "2022-04-21T04:00:00Z",
            "groups": [],
            "value": 18,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-21T04:00:00Z",
            "endTime": "2022-04-22T04:00:00Z",
            "groups": [],
            "value": 10,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-22T04:00:00Z",
            "endTime": "2022-04-23T04:00:00Z",
            "groups": [],
            "value": 17,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-23T04:00:00Z",
            "endTime": "2022-04-24T04:00:00Z",
            "groups": [],
            "value": 9,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-24T04:00:00Z",
            "endTime": "2022-04-25T04:00:00Z",
            "groups": [],
            "value": 12,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-25T04:00:00Z",
            "endTime": "2022-04-26T04:00:00Z",
            "groups": [],
            "value": 10,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-26T04:00:00Z",
            "endTime": "2022-04-27T04:00:00Z",
            "groups": [],
            "value": 24,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-27T04:00:00Z",
            "endTime": "2022-04-28T04:00:00Z",
            "groups": [],
            "value": 12,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-28T04:00:00Z",
            "endTime": "2022-04-29T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-29T04:00:00Z",
            "endTime": "2022-04-30T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-04-30T04:00:00Z",
            "endTime": "2022-05-01T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-05-01T04:00:00Z",
            "endTime": "2022-05-02T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-02T04:00:00Z",
            "endTime": "2022-05-03T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-03T04:00:00Z",
            "endTime": "2022-05-04T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-04T04:00:00Z",
            "endTime": "2022-05-05T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-05T04:00:00Z",
            "endTime": "2022-05-06T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-06T04:00:00Z",
            "endTime": "2022-05-07T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-07T04:00:00Z",
            "endTime": "2022-05-08T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-08T04:00:00Z",
            "endTime": "2022-05-09T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-09T04:00:00Z",
            "endTime": "2022-05-10T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-10T04:00:00Z",
            "endTime": "2022-05-11T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-11T04:00:00Z",
            "endTime": "2022-05-12T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-12T04:00:00Z",
            "endTime": "2022-05-13T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-13T04:00:00Z",
            "endTime": "2022-05-14T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-14T04:00:00Z",
            "endTime": "2022-05-15T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-15T04:00:00Z",
            "endTime": "2022-05-16T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-16T04:00:00Z",
            "endTime": "2022-05-17T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-17T04:00:00Z",
            "endTime": "2022-05-18T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-18T04:00:00Z",
            "endTime": "2022-05-19T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-19T04:00:00Z",
            "endTime": "2022-05-20T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-20T04:00:00Z",
            "endTime": "2022-05-21T04:00:00Z",
            "groups": [],
            "value": 14,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-21T04:00:00Z",
            "endTime": "2022-05-22T04:00:00Z",
            "groups": [],
            "value": 13,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-22T04:00:00Z",
            "endTime": "2022-05-23T04:00:00Z",
            "groups": [],
            "value": 9,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-23T04:00:00Z",
            "endTime": "2022-05-24T04:00:00Z",
            "groups": [],
            "value": 15,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-24T04:00:00Z",
            "endTime": "2022-05-25T04:00:00Z",
            "groups": [],
            "value": 32,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-25T04:00:00Z",
            "endTime": "2022-05-26T04:00:00Z",
            "groups": [],
            "value": 43,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-26T04:00:00Z",
            "endTime": "2022-05-27T04:00:00Z",
            "groups": [],
            "value": 37,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-27T04:00:00Z",
            "endTime": "2022-05-28T04:00:00Z",
            "groups": [],
            "value": 13,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-28T04:00:00Z",
            "endTime": "2022-05-29T04:00:00Z",
            "groups": [],
            "value": 6,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-29T04:00:00Z",
            "endTime": "2022-05-30T04:00:00Z",
            "groups": [],
            "value": 6,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-30T04:00:00Z",
            "endTime": "2022-05-31T04:00:00Z",
            "groups": [],
            "value": 21,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-05-31T04:00:00Z",
            "endTime": "2022-06-01T04:00:00Z",
            "groups": [],
            "value": 21,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-01T04:00:00Z",
            "endTime": "2022-06-02T04:00:00Z",
            "groups": [],
            "value": 20,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-02T04:00:00Z",
            "endTime": "2022-06-03T04:00:00Z",
            "groups": [],
            "value": 31,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-03T04:00:00Z",
            "endTime": "2022-06-04T04:00:00Z",
            "groups": [],
            "value": 42,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-04T04:00:00Z",
            "endTime": "2022-06-05T04:00:00Z",
            "groups": [],
            "value": 3,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-05T04:00:00Z",
            "endTime": "2022-06-06T04:00:00Z",
            "groups": [],
            "value": 3,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-06T04:00:00Z",
            "endTime": "2022-06-07T04:00:00Z",
            "groups": [],
            "value": 10,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-07T04:00:00Z",
            "endTime": "2022-06-08T04:00:00Z",
            "groups": [],
            "value": 13,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-08T04:00:00Z",
            "endTime": "2022-06-09T04:00:00Z",
            "groups": [],
            "value": 9,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-09T04:00:00Z",
            "endTime": "2022-06-10T04:00:00Z",
            "groups": [],
            "value": 55,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-10T04:00:00Z",
            "endTime": "2022-06-11T04:00:00Z",
            "groups": [],
            "value": 27,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-11T04:00:00Z",
            "endTime": "2022-06-12T04:00:00Z",
            "groups": [],
            "value": 24,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-12T04:00:00Z",
            "endTime": "2022-06-13T04:00:00Z",
            "groups": [],
            "value": 10,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-13T04:00:00Z",
            "endTime": "2022-06-14T04:00:00Z",
            "groups": [],
            "value": 12,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-14T04:00:00Z",
            "endTime": "2022-06-15T04:00:00Z",
            "groups": [],
            "value": 25,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-15T04:00:00Z",
            "endTime": "2022-06-16T04:00:00Z",
            "groups": [],
            "value": 16,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-16T04:00:00Z",
            "endTime": "2022-06-17T04:00:00Z",
            "groups": [],
            "value": 19,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-17T04:00:00Z",
            "endTime": "2022-06-18T04:00:00Z",
            "groups": [],
            "value": 2,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-18T04:00:00Z",
            "endTime": "2022-06-19T04:00:00Z",
            "groups": [],
            "value": 1,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-19T04:00:00Z",
            "endTime": "2022-06-20T04:00:00Z",
            "groups": [],
            "value": 3,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-20T04:00:00Z",
            "endTime": "2022-06-21T04:00:00Z",
            "groups": [],
            "value": 6,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-21T04:00:00Z",
            "endTime": "2022-06-22T04:00:00Z",
            "groups": [],
            "value": 9,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-22T04:00:00Z",
            "endTime": "2022-06-23T04:00:00Z",
            "groups": [],
            "value": 27,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-23T04:00:00Z",
            "endTime": "2022-06-24T04:00:00Z",
            "groups": [],
            "value": 28,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-24T04:00:00Z",
            "endTime": "2022-06-25T04:00:00Z",
            "groups": [],
            "value": 11,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-25T04:00:00Z",
            "endTime": "2022-06-26T04:00:00Z",
            "groups": [],
            "value": 0,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-26T04:00:00Z",
            "endTime": "2022-06-27T04:00:00Z",
            "groups": [],
            "value": 3,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-27T04:00:00Z",
            "endTime": "2022-06-28T04:00:00Z",
            "groups": [],
            "value": 24,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-28T04:00:00Z",
            "endTime": "2022-06-29T04:00:00Z",
            "groups": [],
            "value": 13,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-29T04:00:00Z",
            "endTime": "2022-06-30T04:00:00Z",
            "groups": [],
            "value": 12,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-06-30T04:00:00Z",
            "endTime": "2022-07-01T04:00:00Z",
            "groups": [],
            "value": 23,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-01T04:00:00Z",
            "endTime": "2022-07-02T04:00:00Z",
            "groups": [],
            "value": 36,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-02T04:00:00Z",
            "endTime": "2022-07-03T04:00:00Z",
            "groups": [],
            "value": 1,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-03T04:00:00Z",
            "endTime": "2022-07-04T04:00:00Z",
            "groups": [],
            "value": 4,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-04T04:00:00Z",
            "endTime": "2022-07-05T04:00:00Z",
            "groups": [],
            "value": 32,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-05T04:00:00Z",
            "endTime": "2022-07-06T04:00:00Z",
            "groups": [],
            "value": 10,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-06T04:00:00Z",
            "endTime": "2022-07-07T04:00:00Z",
            "groups": [],
            "value": 10,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-07T04:00:00Z",
            "endTime": "2022-07-08T04:00:00Z",
            "groups": [],
            "value": 13,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-08T04:00:00Z",
            "endTime": "2022-07-09T04:00:00Z",
            "groups": [],
            "value": 8,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-09T04:00:00Z",
            "endTime": "2022-07-10T04:00:00Z",
            "groups": [],
            "value": 2,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-10T04:00:00Z",
            "endTime": "2022-07-11T04:00:00Z",
            "groups": [],
            "value": 1,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-11T04:00:00Z",
            "endTime": "2022-07-12T04:00:00Z",
            "groups": [],
            "value": 39,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-12T04:00:00Z",
            "endTime": "2022-07-13T04:00:00Z",
            "groups": [],
            "value": 30,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-13T04:00:00Z",
            "endTime": "2022-07-14T04:00:00Z",
            "groups": [],
            "value": 40,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-14T04:00:00Z",
            "endTime": "2022-07-15T04:00:00Z",
            "groups": [],
            "value": 252,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-15T04:00:00Z",
            "endTime": "2022-07-16T04:00:00Z",
            "groups": [],
            "value": 209,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-16T04:00:00Z",
            "endTime": "2022-07-17T04:00:00Z",
            "groups": [],
            "value": 89,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-17T04:00:00Z",
            "endTime": "2022-07-18T04:00:00Z",
            "groups": [],
            "value": 91,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-18T04:00:00Z",
            "endTime": "2022-07-19T04:00:00Z",
            "groups": [],
            "value": 282,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-19T04:00:00Z",
            "endTime": "2022-07-20T04:00:00Z",
            "groups": [],
            "value": 237,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-20T04:00:00Z",
            "endTime": "2022-07-21T04:00:00Z",
            "groups": [],
            "value": 237,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-21T04:00:00Z",
            "endTime": "2022-07-22T04:00:00Z",
            "groups": [],
            "value": 288,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-22T04:00:00Z",
            "endTime": "2022-07-23T04:00:00Z",
            "groups": [],
            "value": 141,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-23T04:00:00Z",
            "endTime": "2022-07-24T04:00:00Z",
            "groups": [],
            "value": 45,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-24T04:00:00Z",
            "endTime": "2022-07-25T04:00:00Z",
            "groups": [],
            "value": 81,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-25T04:00:00Z",
            "endTime": "2022-07-26T04:00:00Z",
            "groups": [],
            "value": 173,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-26T04:00:00Z",
            "endTime": "2022-07-27T04:00:00Z",
            "groups": [],
            "value": 199,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-27T04:00:00Z",
            "endTime": "2022-07-28T04:00:00Z",
            "groups": [],
            "value": 172,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-28T04:00:00Z",
            "endTime": "2022-07-29T04:00:00Z",
            "groups": [],
            "value": 185,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-29T04:00:00Z",
            "endTime": "2022-07-30T04:00:00Z",
            "groups": [],
            "value": 140,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-30T04:00:00Z",
            "endTime": "2022-07-31T04:00:00Z",
            "groups": [],
            "value": 94,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-07-31T04:00:00Z",
            "endTime": "2022-08-01T04:00:00Z",
            "groups": [],
            "value": 76,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-01T04:00:00Z",
            "endTime": "2022-08-02T04:00:00Z",
            "groups": [],
            "value": 195,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-02T04:00:00Z",
            "endTime": "2022-08-03T04:00:00Z",
            "groups": [],
            "value": 220,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-03T04:00:00Z",
            "endTime": "2022-08-04T04:00:00Z",
            "groups": [],
            "value": 280,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-04T04:00:00Z",
            "endTime": "2022-08-05T04:00:00Z",
            "groups": [],
            "value": 273,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-05T04:00:00Z",
            "endTime": "2022-08-06T04:00:00Z",
            "groups": [],
            "value": 189,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-06T04:00:00Z",
            "endTime": "2022-08-07T04:00:00Z",
            "groups": [],
            "value": 182,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-07T04:00:00Z",
            "endTime": "2022-08-08T04:00:00Z",
            "groups": [],
            "value": 150,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-08T04:00:00Z",
            "endTime": "2022-08-09T04:00:00Z",
            "groups": [],
            "value": 213,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-09T04:00:00Z",
            "endTime": "2022-08-10T04:00:00Z",
            "groups": [],
            "value": 283,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-10T04:00:00Z",
            "endTime": "2022-08-11T04:00:00Z",
            "groups": [],
            "value": 364,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-11T04:00:00Z",
            "endTime": "2022-08-12T04:00:00Z",
            "groups": [],
            "value": 277,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-12T04:00:00Z",
            "endTime": "2022-08-13T04:00:00Z",
            "groups": [],
            "value": 215,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-13T04:00:00Z",
            "endTime": "2022-08-14T04:00:00Z",
            "groups": [],
            "value": 124,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-14T04:00:00Z",
            "endTime": "2022-08-15T04:00:00Z",
            "groups": [],
            "value": 110,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-15T04:00:00Z",
            "endTime": "2022-08-16T04:00:00Z",
            "groups": [],
            "value": 240,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-16T04:00:00Z",
            "endTime": "2022-08-17T04:00:00Z",
            "groups": [],
            "value": 530,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-17T04:00:00Z",
            "endTime": "2022-08-18T04:00:00Z",
            "groups": [],
            "value": 257,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-18T04:00:00Z",
            "endTime": "2022-08-19T04:00:00Z",
            "groups": [],
            "value": 252,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-19T04:00:00Z",
            "endTime": "2022-08-20T04:00:00Z",
            "groups": [],
            "value": 163,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-20T04:00:00Z",
            "endTime": "2022-08-21T04:00:00Z",
            "groups": [],
            "value": 97,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-21T04:00:00Z",
            "endTime": "2022-08-22T04:00:00Z",
            "groups": [],
            "value": 127,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-22T04:00:00Z",
            "endTime": "2022-08-23T04:00:00Z",
            "groups": [],
            "value": 213,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-23T04:00:00Z",
            "endTime": "2022-08-24T04:00:00Z",
            "groups": [],
            "value": 261,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-24T04:00:00Z",
            "endTime": "2022-08-25T04:00:00Z",
            "groups": [],
            "value": 179,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-25T04:00:00Z",
            "endTime": "2022-08-26T04:00:00Z",
            "groups": [],
            "value": 257,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-26T04:00:00Z",
            "endTime": "2022-08-27T04:00:00Z",
            "groups": [],
            "value": 161,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-27T04:00:00Z",
            "endTime": "2022-08-28T04:00:00Z",
            "groups": [],
            "value": 77,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-28T04:00:00Z",
            "endTime": "2022-08-29T04:00:00Z",
            "groups": [],
            "value": 65,
            "isPartialPeriod": false
          }
        ],
        "numGroups": "0"
      }
    },
    "direction": 1,
    "periodicStats": [
      {
        "startDate": "2022-05-01T04:00:00Z",
        "endDate": "2022-05-31T04:00:00Z",
        "mean": 6.966666666666667
      },
      {
        "startDate": "2022-05-31T04:00:00Z",
        "endDate": "2022-06-30T04:00:00Z",
        "mean": 15.966666666666667
      },
      {
        "startDate": "2022-06-30T04:00:00Z",
        "endDate": "2022-07-30T04:00:00Z",
        "mean": 102.33333333333333
      },
      {
        "startDate": "2022-07-30T04:00:00Z",
        "endDate": "2022-08-29T04:00:00Z",
        "mean": 204.13333333333333
      }
    ],
    "ratioChange": 3.559430398140076
  }
}
